import { render, staticRenderFns } from "./probationFormA.vue?vue&type=template&id=39b9a7fe&"
import script from "./probationFormA.vue?vue&type=script&lang=js&"
export * from "./probationFormA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports